var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleSexIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.176 12V10.056H2.052V9.21H4.176V7.626C3.564 7.542 3.012 7.326 2.52 6.978C2.028 6.63 1.638 6.186 1.35 5.646C1.062 5.106 0.918 4.524 0.918 3.9C0.918 3.228 1.086 2.616 1.422 2.064C1.77 1.5 2.226 1.05 2.79 0.713999C3.366 0.377999 3.99 0.209999 4.662 0.209999C5.346 0.209999 5.97 0.377999 6.534 0.713999C7.11 1.05 7.566 1.5 7.902 2.064C8.238 2.616 8.406 3.228 8.406 3.9C8.406 4.512 8.262 5.088 7.974 5.628C7.686 6.168 7.296 6.618 6.804 6.978C6.324 7.326 5.772 7.542 5.148 7.626V9.21H7.146V10.056H5.148V12H4.176ZM4.662 6.744C5.178 6.744 5.652 6.618 6.084 6.366C6.516 6.102 6.858 5.754 7.11 5.322C7.374 4.89 7.506 4.416 7.506 3.9C7.506 3.396 7.374 2.934 7.11 2.514C6.858 2.094 6.516 1.758 6.084 1.506C5.652 1.242 5.178 1.11 4.662 1.11C4.146 1.11 3.672 1.242 3.24 1.506C2.808 1.758 2.46 2.094 2.196 2.514C1.944 2.934 1.818 3.396 1.818 3.9C1.818 4.416 1.944 4.89 2.196 5.322C2.46 5.754 2.808 6.102 3.24 6.366C3.672 6.618 4.146 6.744 4.662 6.744Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleSexIcon);
export default __webpack_public_path__ + "static/media/female_sex_icon.13b823ac11b8191a0014021cd09ceda3.svg";
export { ForwardRef as ReactComponent };